import { GlobalSettings } from 'types/GlobalSettings'

import { httpClient } from './clients/httpClient'

export const getAllSettings = async (): Promise<GlobalSettings> => {
    try {
        const { data } = await httpClient.get<GlobalSettings>('/global-settings')
        return data
    } catch (error) {
        console.error('Failed to fetch global settings:', error)
        throw new Error('Failed to fetch global settings')
    }
}

export const updateSystemUsageFee = async (systemUsageFeePerTicket: number): Promise<GlobalSettings> => {
    try {
        const { data } = await httpClient.put<GlobalSettings>('/global-settings/system-usage-fee', {
            systemUsageFeePerTicket,
        })
        return data
    } catch (error) {
        console.error('Failed to update system usage fee:', error)
        throw new Error('Failed to update system usage fee')
    }
}
